// extracted by mini-css-extract-plugin
export default {"icon":"IsPrivateField_icon__SAD6K"};